export default __webpack_public_path__ + "static/AeonikRegular-2766be716875bd52ca7669bb92317b19.otf";